const integrations = [
  { name: 'Stripe', cat: 'Platební brána', file: 'stripe.webp' },
  { name: 'PayPal', cat: 'Platební brána', file: 'paypal.png' },
  { name: 'Comgate', cat: 'Platební brána', file: 'comgate.jpg' },
  { name: 'Shoptet', cat: 'E-commerce', file: 'shoptet_pay.jpeg' },
  { name: 'WooCommerce', cat: 'E-commerce', file: 'woocommerce.jpg' },
  { name: 'Upgates', cat: 'E-commerce', file: 'upgates.png' },
  { name: 'Etsy', cat: 'Marketplace', file: 'etsy.png' },
  { name: 'Mews', cat: 'Hotel PMS', file: 'mews.webp' },
  { name: 'Zásilkovna', cat: 'Doprava', file: 'Zasilkovna.png' },
  { name: 'DPD', cat: 'Doprava', file: 'dpd.png' },
  { name: 'FAPI', cat: 'Fakturace', file: 'fapi.png' },
  { name: 'Money S3', cat: 'Účetnictví', file: 'moneyS3.webp' },
];

export default function IntegrationsGrid() {
  return (
    <section className="integrations-section" id="integrations">
      <div className="container">
        <div className="section-header">
          <span className="section-label">25+ integrací</span>
          <h2>Propojíme, co používáte</h2>
          <p>A pokud váš systém v seznamu není, vytvoříme integraci na míru.</p>
        </div>
        <div className="integrations-grid">
          {integrations.map(int => (
            <div key={int.name} className="integration-pill">
              <img src={`/integrations/${int.file}`} alt={int.name} />
              <div><div className="integration-pill-name">{int.name}</div><div className="integration-pill-cat">{int.cat}</div></div>
            </div>
          ))}
        </div>
        <p className="integrations-note">
          Nenašli jste svůj systém? <strong>Nevadí.</strong> <a href="#cta">Napište nám</a> — většinu integrací vytvoříme do 2 týdnů.
        </p>
      </div>
    </section>
  );
}
